"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var theme_1 = require("../../theme");
var react_1 = require("react");
var classnames_1 = require("classnames");
var ToggleSwitch = function (_a) {
    var status = _a.status, onToggle = _a.onToggle, isDisabled = _a.isDisabled;
    var bgColors = (0, theme_1.useBackgroundColors)();
    var _b = (0, react_1.useState)(status), toggleStatus = _b[0], setToggleStatus = _b[1];
    var disabled = isDisabled !== undefined
        ? isDisabled instanceof Function
            ? isDisabled()
            : isDisabled
        : false;
    var switchAnimationClasses = [
        'squid-transition',
        'squid-duration-200',
        'squid-ease-in-out',
    ];
    var handleToggle = function () {
        if (disabled) {
            return;
        }
        setToggleStatus(!toggleStatus);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!toggleStatus);
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: handleToggle, className: (0, classnames_1.default)('squid-h-component-toggle-height', 'squid-w-component-toggle-width', 'squid-p-component-toggle-padding-base', 'squid-rounded-component-toggle-border-radius', switchAnimationClasses, toggleStatus ? bgColors.primary : bgColors.neutral, {
            'hover:squid-shadow-[0_0_0_5px_rgba(36,39,49,0.05)]': !isDisabled,
            'active:squid-shadow-[0_0_0_8px_rgba(36,39,49,0.05)]': !isDisabled,
        }) }, { children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('squid-w-component-toggle-handle-size', 'squid-h-component-toggle-handle-size', 'squid-rounded-alias-border-radius-circle', 'squid-bg-component-toggle-color-default', switchAnimationClasses, { 'squid-translate-x-[1rem]': toggleStatus }) }) })));
};
exports.ToggleSwitch = ToggleSwitch;
